module.exports = __webpack_public_path__ + "media/ring-phone.0848843b.mp3";